import { findCurrUser, getUserAllTenants, getUserApplications, getAllResources } from '@/modules/index/api/user';
import lang from '@/lang/index';
import config from '@/config/user.env';
import { MessageBox, Message } from 'element-ui';
import Popup from '../../modules/sn/components/permuatDialog/index';
import { logout } from '@/utils/index';
import utils from '@/utils/common.js';
import cookies from 'js-cookie';
import initVolacnoBasepoint from '@/utils/volcanoEngine/index.js';
export default {
    state: {
        user: {},
        authority: '',
        appId: config.appId,
        lang: {},
        tenantInfo: {},
        currentTenant: {},
        appList: [],
        applicationCode: '',
        isShowLang: true,
        locale: '',
        langInfo: {}
    },
    getters: {
        user: state => state.user,
        appId: state => state.appId,
        authority: state => state.authority,
        menus: state => {
            if (state.authority) {
                return state.authority;
            }
            return [];
        },
        lang: state => state.lang,
        tenantInfo: state => state.tenantInfo,
        currentTenant: state => state.currentTenant,
        appList: state => state.appList,
        btnPermissions: state => state.btnPermissions,
        applicationCode: state => state.applicationCode,
        isShowLang: state => state.isShowLang,
        locale: state => state.locale,
        langInfo: state => state.langInfo

    },
    mutations: {
        getBtnPermissions(state, btnPermissions) {
            state.btnPermissions = btnPermissions;
        },
        updateUserInfo(state, user) {
            state.user = user;
        },
        updateAuthority(state, authority) {
            state.authority = authority;
        },
        updateLang(state, _lang) {
            state.lang = _lang;
        },
        updateTenant(state, _tenantInfo) {
            state.tenantInfo = _tenantInfo;
        },
        updateCurrenTenant(state, _tenantInfo) {
            state.currentTenant = _tenantInfo;
        },
        updateAppList(state, _appList) {
            state.appList = _appList;
        },
        updateApplicationCode(state, _applicationCode) {
            state.applicationCode = _applicationCode;
        },
        updateLangInfo(state, LangInfo) {
            state.langInfo = LangInfo;
        },
        updateLocale(state, locale) {
            // 设置接口的cookie
            // cookies.set('lang', locale, { domain: '.midea.com' });
            cookies.set('lang', locale, { domain: config.domain });
            // 设置时区
            var d = new Date();
            var gmtHours = d.getTimezoneOffset() / 60;
            gmtHours = -gmtHours;
            let sign = '+';
            if (gmtHours < 0) {
                sign = '-';
            }
            const numLength = 2; // 数字长度 前面补0
            gmtHours = (Array(numLength).join(0) + gmtHours).slice(-numLength);
            cookies.set('timezone', 'GMT' + sign + gmtHours + ':00', { domain: config.domain });
            state.locale = locale;
        }
    },
    actions: {
        /**
         * 初始化系统
         * @param {*} param0
         */
        initSystem({ commit }) {
            const params = {
                listFlag: 1,
                pageNo: 1,
                pageSize: 10
            };
            return Promise.all([findCurrUser(), getUserAllTenants(params)]).then(res => {
                if (+res[0].code === 0 && res[0].msg !== 'qxtz' && +res[1].code === 0) {
                    commit('updateUserInfo', res[0].data);
                    if (!res[1].data.currentTenant) {
                        MessageBox.alert('不存在默认租户，请联系管理员授权登录!', '错误', {
                            confirmButtonText: '确定',
                            callback: action => {
                                logout();
                            }
                        });
                        return false;
                    }
                    commit('updateTenant', res[1].data.tenants ? res[1].data.tenants : {});
                    commit('updateCurrenTenant', res[1].data.currentTenant ? res[1].data.currentTenant : {});
                    initVolacnoBasepoint({
                        // 停留时长功能
                        enable_stay_duration: true,
                        // 自动重置时长  路由切换时进行重置
                        disable_route_report: true
                    });
                    return getUserApplications({
                        userCode: res[0].data.userCode,
                        tenantCode: res[1].data.currentTenant.tenantCode
                    }).then(response => {
                        if (response && +response.code === 0) {
                            if (!response.data.length) {
                                MessageBox.alert('不存在应用列表，请联系管理员重新登录!', '错误', {
                                    confirmButtonText: '确定'
                                });
                                return false;
                            }
                            commit('updateAppList', response.data);
                            const appId = response.data.find(item => {
                                return item.applicationDomain && item.applicationDomain.indexOf(window.location.pathname) > -1;
                            });
                            commit('updateApplicationCode', (appId && appId['applicationCode']) || '');
                            localStorage.setItem('applicationCode', (appId && appId['applicationCode']) || '');
                            return getAllResources({
                                userCode: res[0].data.userCode,
                                applicationCode: appId && appId['applicationCode'] ? appId['applicationCode'] : '',
                                tenantCode: res[1].data.currentTenant.tenantCode
                            }).then(resData => {
                                if (resData && +resData.code === 0) {
                                    const btnPermissions = utils.getResourceIds(resData.data);
                                    commit('getBtnPermissions', btnPermissions);
                                    commit('updateAuthority', resData.data[0] && resData.data[0].subResources && resData.data[0].subResources.length ? resData.data[0].subResources : []);
                                    if (resData.data && resData.data.length === 0) {
                                        Message.error({
                                            message: '您没有菜单权限',
                                            showClose: true
                                        });
                                    }
                                    return true;
                                } else {
                                    Message.error(resData.msg);
                                    return false;
                                }
                            });
                        } else {
                            Message.error(response.msg);
                            return false;
                        }
                    });
                } else if (+res[0].code === 0 && res[0].msg === 'qxtz' && +res[1].code === 0) {
                    Popup.install({ dialogVisible: true });
                } else {
                    if (res[0] && +res[0].code !== 0) {
                        MessageBox.alert(res[0].msg || '接口返回异常', '错误', {
                            confirmButtonText: '确定',
                            callback: action => {
                                logout();
                            }
                        });
                    }
                    if (res[1] && +res[1].code !== 0) {
                        MessageBox.alert(res[1].msg || '接口返回异常', '错误', {
                            confirmButtonText: '确定',
                            callback: action => {
                                logout();
                            }
                        });
                    }
                }
                // return +res[0].code === 0 && +res[1].code === 0;
            });
        },
        UPDATE_LANG({ commit, state }) {
            const langSettings = lang.initLanguage(state.locale);
            commit('updateLang', langSettings);
            return langSettings;
        }
    }
};
